import Vuex from 'vuex'
import Vue from 'vue'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // CustomerServiceHomeNew
    refreshList: null,
    orderList: null,
    stepList: null,
    seller: null,

    selected: null,
    selected2: null,
    selected3: null,

    // FollowUpListNew
    name: null,
    date: null,

    // ValidationListNew
    validationRefreshList: null,
    validationOrderList: null,
    validationSeller: null,

    validationSelected: null,
    validationSelected2: null,

    serviceStatus: false
  },

  actions: {
    // CustomerServiceHomeNew
    selecionouOpcao (context, payload) {
      context.state.orderList = payload
      context.state.refreshList =
        context.state.refreshList === null ? true : !context.state.refreshList
    },
    selecionouOpcao2 (context, payload) {
      context.state.stepList = payload
      context.state.refreshList =
        context.state.refreshList === null ? true : !context.state.refreshList
    },
    selecionouOpcao3 (context, payload) {
      context.state.seller = payload
      context.state.refreshList =
        context.state.refreshList === null ? true : !context.state.refreshList
    },
    setSelected: function (context, payload) {
      context.state.selected = payload
    },
    setSelected2: function (context, payload) {
      context.state.selected2 = payload
    },
    setSelected3: function (context, payload) {
      context.state.selected3 = payload
    },

    // FollowUpListNew
    buscarComFiltro: function (context, payload) {
      context.state.name = payload
    },
    buscarComData: function (context, payload) {
      context.state.date = payload
    },
    resetFields: function (context) {
      // CustomerServiceHomeNew
      context.state.refreshList = null
      context.state.orderList = null
      context.state.stepList = null
      context.state.seller = null

      context.state.selected = null
      context.state.selected2 = null
      context.state.selected3 = null

      // FollowUpListNew
      context.state.name = null
      context.state.date = null
    },

    // ValidationListNew
    validationSelecionouOpcao (context, payload) {
      context.state.validationOrderList = payload
      context.state.validationRefreshList =
        context.state.validationRefreshList === null ? true : !context.state.validationRefreshList
    },
    validationSelecionouOpcao2 (context, payload) {
      context.state.validationSeller = payload
      context.state.validationRefreshList =
        context.state.validationRefreshList === null ? true : !context.state.validationRefreshList
    },
    setValidationSelected: function (context, payload) {
      context.state.validationSelected = payload
    },
    setValidationSelected2: function (context, payload) {
      context.state.validationSelected2 = payload
    },
    serviceStatusSelected (context, payload) {
      context.state.serviceStatus = payload
      context.state.validationRefreshList =
        context.state.validationRefreshList === null ? true : !context.state.validationRefreshList
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js